// get
export const GET = async (url, token) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
    .then(res => res.json())
    .then(body => {
      if (body.error) {
        throw body;
      }
      return body;
    });

  return response;
};

// post
export const POST = async (url, payload, token) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  })
    .then(res => res.json())
    .then(body => {
      if (body.error) {
        throw body;
      }
      return body;
    });

  return response;
};

export const loginDisbursements = async token => {
  const response = await POST('/api/v1/disbursement_portal/login', {}, token);
  return response;
};

// verify token
export const verifyToken = async (payload, token) => {
  const response = await POST(
    '/api/v1/disbursement_portal/verify',
    payload,
    token
  );
  return response;
};

// get disbursements
export const getDisbursements = async token => {
  const response = await GET(
    '/api/v1/disbursement_portal/disbursements',
    token
  );
  return response;
};

// get transfer-options
export const getTransferOptions = async token => {
  const response = await GET(
    '/api/v1/disbursement_portal/transfer-options',
    token
  );
  return response;
};

// get etransfer config
export const getEtransferConfig = async token => {
  const response = await GET(
    '/api/v1/disbursement_portal/etransfer/config',
    token
  );
  return response;
};

// post auto deposit check
export const postAutoDepositCheck = async (payload, token) => {
  const response = await POST(
    '/api/v1/disbursement_portal/etransfer/auto-deposit-check',
    payload,
    token
  );
  return response;
};

// create external account
export const createExternalAccount = async (payload, token) => {
  const response = await POST(
    '/api/v1/disbursement_portal/redeem/external_accounts',
    payload,
    token
  );
  return response;
};

// create external transfer
export const createExternalTransfer = async (payload, token) => {
  const response = await POST(
    '/api/v1/disbursement_portal/redeem/external_transfers',
    payload,
    token
  );
  return response;
};

// create account
export const createAccount = async (payload, token) => {
  const response = await POST(
    '/api/v1/disbursement_portal/redeem/register',
    payload,
    token
  );
  return response;
};
